<template>
  <div class="email-reset-inviata">
    <h3>{{ labels.email_reset_inviata }}: {{ utente }}.</h3>
    <br />
    <p>{{ labels.nell_email_contenuto_link }}</p>
    <p>{{ labels.se_email_non_arriva }}</p>

    <br />
    <router-link to="/">Login</router-link>
  </div>
</template>

<script>
export default {
  name: "EmailResetInviata",
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },
  props: {
    utente: String,
  },
  created() {
    fn_CambiaLingua(this.$store.state.Lingua, this);
  },
};
function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {
      email_reset_inviata: "E' stata inviata un'email all'utente",
      nell_email_contenuto_link:
        "All'interno dell'email è presente un link che permette di inserire una nuova password.",
      se_email_non_arriva:
        "Se l'email non dovesse arrivare entro un tempo ragionevole, si controlli nella casella della posta indesiderata (spam).",
    };
    let labels_inglese = {
      email_reset_inviata: "E' stata inviata un'email all'utente",
      nell_email_contenuto_link:
        "All'interno dell'email è presente un link che permette di inserire una nuova password.",
      se_email_non_arriva:
        "Se l'email non dovesse arrivare entro un tempo ragionevole, si controlli nella casella della posta indesiderata (spam).",
    };
    let labels_tedesco = {
      email_reset_inviata: "E' stata inviata un'email all'utente",
      nell_email_contenuto_link:
        "All'interno dell'email è presente un link che permette di inserire una nuova password.",
      se_email_non_arriva:
        "Se l'email non dovesse arrivare entro un tempo ragionevole, si controlli nella casella della posta indesiderata (spam).",
    };
    let labels_francese = {
      email_reset_inviata:
        "E' stata inviata un'email all'indirizzo memorizzato nell'utente indicato. ",
      nell_email_contenuto_link:
        "All'interno dell'email è presente un link che permette di inserire una nuova password.",
      se_email_non_arriva:
        "Se l'email non dovesse arrivare entro un tempo ragionevole, si controlli nella casella della posta indesiderata (spam).",
    };

    let labels_errori_italiano = {};
    let labels_errori_inglese = {};
    let labels_errori_tedesco = {};
    let labels_errori_francese = {};

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(error, "EmilResetInviata-fn_CambiaLingua");
  }
}
</script>

<style scoped></style>
